import { render, staticRenderFns } from "./ticketAcceptRecord.vue?vue&type=template&id=180c698b&"
import script from "./ticketAcceptRecord.vue?vue&type=script&lang=js&"
export * from "./ticketAcceptRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180c698b')) {
      api.createRecord('180c698b', component.options)
    } else {
      api.reload('180c698b', component.options)
    }
    module.hot.accept("./ticketAcceptRecord.vue?vue&type=template&id=180c698b&", function () {
      api.rerender('180c698b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/ticketShare/ticketAcceptRecord.vue"
export default component.exports